module.exports = function($){
  $.FW   = true;
  $.path = $.g;
  return $;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.fw.js
 ** module id = 82
 ** module chunks = 0
 **/